import React, { useState } from "react";
import { Img } from "../../../core/design-system/Img";
import { Text } from "../../../core/design-system/Text";
import { selectPortFolio } from "../../../dashboard/redux/accountSlice";
import { useSelector } from "react-redux";

interface AccountPickerProps {
  selectAccount: (account: any) => void;
  selectedAccount: any;
}
const defaultState = {
  isOptionsVisible: false,
};
const AccountPicker: React.FC<AccountPickerProps> = (props) => {
  const portfolio = useSelector(selectPortFolio);
  const [state, setstate] = useState(defaultState);
  const onSelectAccount = (account: any) => {
    setstate({ ...state, isOptionsVisible: false });
    props.selectAccount(account);
  };
  const toggleOptions = () => {
    setstate({ ...state, isOptionsVisible: !state.isOptionsVisible });
  };
  console.log("props.selectedAccount", props.selectedAccount);

  return (
    <>
      <div
        className="flex  flex-row p-2 pr-4 border border-gray-300_01 rounded-lg gap-4 "
        onClick={toggleOptions}
      >
        <Img src="visaIcon.svg" alt="back" className="xs:size-10 5xl:size-14" />
        <div className="flex flex-col">
          <div className="flex felx-row gap-1 items-center">
            <Text
              size="md"
              className="whitespace-nowrap  text-gray-50_04 xs:font-medium 5xl:font-normal 5xl:text-lg"
            >
              {props.selectedAccount?.name ?? "Saving Account"}
            </Text>
            <Img
              src="img_arrowdown.svg"
              alt="back"
              className="xs:size-5 5xl:size-6"
            />
          </div>
          <Text
            size="s"
            className="whitespace-nowrap  text-[12px] text-left opacity-50 text-gray-50_04 font-medium"
          >
            {`•••${props.selectedAccount?.id?.slice(31) ?? "1234"}`}
          </Text>
        </div>
      </div>
      {/* create a dropdown view here */}
      {state.isOptionsVisible && (
        <div className="absolute top-[9rem] back left-30 z-50 p-5 bg-white-A700 border border-gray-300_01 rounded-lg">
          {portfolio.youHaveAccounts.map((account: any) => (
            <div
              className="m-2 hover:cursor-pointer text-left"
              key={account.id}
              onClick={() => onSelectAccount(account)}
            >
              {account.name}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default AccountPicker;
